import type {Repository} from '@github-ui/current-repository'
import type {PageError} from '@github-ui/react-core/app-routing-types'
import type {CurrentUser, RefInfo} from '@github-ui/repos-types'
import type {ReposFileTreeData, TreePayload} from './tree-types'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isErrorPayload(payload: any): payload is DataRouterErrorPayload {
  return 'error' in payload
}

export interface DataRouterErrorPayload {
  path: string
  repo: Repository
  refInfo: RefInfo
  currentUser: CurrentUser
  fileTree: ReposFileTreeData
  fileTreeProcessingTime: number
  foldersToFetch: string[]
  allShortcutsEnabled: boolean
  tree: TreePayload
  error: PageError
  isMarketplaceEnabled?: boolean
  copilotAccessAllowed?: boolean
  copilotSpacesEnabled?: boolean
  modelsAccessAllowed?: boolean
  modelsRepoIntegrationEnabled?: boolean
}
